type ReactEnv = {
    REACT_APP_API_SERVER_URL: string;
};

interface ReactWindow extends Window {
    REACT_ENV_FT_FRONT_FRONTTOOL_MODULE: ReactEnv;
}

declare let window: ReactWindow;
const env = process?.env?.NODE_ENV === "development" ? {} as ReactEnv : window.REACT_ENV_FT_FRONT_FRONTTOOL_MODULE;

export default env;
